<template>
     <a :href="href">{{ text }}</a>
</template>

<script>
import framework from '../../framework';

/**
 *  The x-anchor component.
 *  @module components/x-anchor
 */


/**
 * The x-anchor is a basic anchor.
 */

export default {
    name: 'x-anchor',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: [
        'dataHref',
        'dataText',
    ],
    computed: {
        /**
         * The href for the anchor
         * @returns {string} the text string.
         */
        href() {
            return this.getAttribute('href', '#');
        },

        /**
         * The text for the anchor
         * @returns {string} the text string.
         */
        text() {
            return this.getAttribute('text', 'link text');
        },
    },
};
</script>
<style lang="scss">
    @import
        "../../styles/settings",
        "anchor";
</style>



// WEBPACK FOOTER //
// source/components/x-anchor/x-anchor.vue